  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Ensure that autoplaySpeed is defined
      const autoplaySpeed = this.getAttribute('data-autoplay-speed') || 3000;

      // Find navigation elements within the custom element's scope
      const nextButton = this.querySelector('.swiper-button-next-custom');
      const prevButton = this.querySelector('.swiper-button-prev-custom');
      const pagination = this.querySelector('.swiper-pagination');

      this.swiper = new Swiper(this, {
        spaceBetween: 15,
        slidesPerView: 1,
        loop: true,
        mousewheel: {
          forceToAxis: true
        },
        // autoplay: {
        //   delay: parseInt(autoplaySpeed, 10),
        //   disableOnInteraction: true
        // },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          540: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          750: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          990: {
            slidesPerView: 5,
            spaceBetween: 20
          }
        },
        pagination: {
          el: pagination,
          clickable: true
        }
      });
    }
  }

  customElements.define('products-carousel', ProductsCarousel);

// Two 
  class ProductsCarouselRelatedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Ensure that autoplaySpeed is defined
      const autoplaySpeed = this.getAttribute('data-autoplay-speed') || 3000;

      // Find navigation elements within the custom element's scope
      const nextButton = this.querySelector('.swiper-button-next-custom');
      const prevButton = this.querySelector('.swiper-button-prev-custom');
      const pagination = this.querySelector('.swiper-pagination');

      this.swiper = new Swiper(this, {
        spaceBetween: 15,
        slidesPerView: 1,
        loop: true,
        mousewheel: {
          forceToAxis: true
        },
        // autoplay: {
        //   delay: parseInt(autoplaySpeed, 10),
        //   disableOnInteraction: true
        // },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          540: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          750: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        },
        pagination: {
          el: pagination,
          clickable: true
        }
      });
    }
  }

  customElements.define('products-carousel-related-products', ProductsCarouselRelatedProducts);